
import React from 'react';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { useTranslation } from 'react-i18next';
import { languages, timezones } from '@/utils/profile-options';
import { TimezoneSelector } from '@/components/common/TimezoneSelector';

interface PreferencesFormProps {
  defaultValues: {
    timezone: string;
    preferred_language: string;
  };
  onSubmit: (values: any) => void;
  isSubmitting?: boolean;
}

const PreferencesForm: React.FC<PreferencesFormProps> = ({ 
  defaultValues, 
  onSubmit, 
  isSubmitting = false
}) => {
  const { t } = useTranslation('dashboard');

  return (
    <div className="space-y-6">
      <div>
        <Label htmlFor="timezone">{t('preferences.timezone')}</Label>
        <Select name="timezone" defaultValue={defaultValues.timezone || "America/New_York"} disabled={isSubmitting}>
          <SelectTrigger>
            <SelectValue placeholder={t('preferences.selectTimezone')} />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            {timezones.map((timezone) => (
              <SelectItem key={timezone.value} value={timezone.value}>
                {timezone.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
        <p className="text-xs text-muted-foreground mt-1">
          {t('preferences.timezoneNote')}
        </p>
      </div>
      
      <div>
        <Label htmlFor="preferred_language">{t('preferences.preferredLanguage')}</Label>
        <Select name="preferred_language" defaultValue={defaultValues.preferred_language || "en"} disabled={isSubmitting}>
          <SelectTrigger>
            <SelectValue placeholder={t('preferences.selectLanguage')} />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            {languages.map((language) => (
              <SelectItem key={language.value} value={language.value}>
                {language.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
};

export default PreferencesForm;
